import { FC } from "react";
import { ProjectVisitStatus} from "../../api/dto/ProjectVisit";
import {Badge, BadgeStyle} from "./Badge";

export const ProjectVisitStatusLabel: FC<{projectVisitStatus: ProjectVisitStatus|null}> = (props) => {
  const styleMapping = {
    'Concept': BadgeStyle.default,
    'Taak aangemaakt': BadgeStyle.info,
    'Ingepland': BadgeStyle.info,
    'Uitgevoerd': BadgeStyle.success,
    'Geen': BadgeStyle.danger,
  }

  return <Badge style={styleMapping[props.projectVisitStatus ?? 'Geen']}>
    {props.projectVisitStatus ?? 'Onbekend'}
  </Badge>
}
